/* Creche Club — theme scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Announcement bar rotator */
  function initAnnouncements(root) {
    var slides = root.querySelectorAll('.announcement__slide');
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }
    var prev = root.querySelector('[data-ann-prev]');
    var next = root.querySelector('[data-ann-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    setInterval(function () { show(i + 1); }, 5000);
  }

  /* Hero slideshow */
  function initHero(root) {
    var track = root.querySelector('.hero__track');
    var slides = root.querySelectorAll('.hero__slide');
    var dots = root.querySelectorAll('.hero__dot');
    if (!track || slides.length < 2) return;
    function go(n) {
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    track.addEventListener('scroll', function () {
      var c = current();
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === c); });
    }, { passive: true });
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });
    var delay = parseInt(root.getAttribute('data-autoplay'), 10);
    if (delay > 0) {
      setInterval(function () { go(current() + 1); }, delay * 1000);
    }
  }

  /* Mobile menu + search drawer */
  function initHeader() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-nav-bar]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
      });
    }
    var searchBtn = document.querySelector('[data-search-toggle]');
    var drawer = document.querySelector('[data-search-drawer]');
    if (searchBtn && drawer) {
      searchBtn.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', open);
        if (open) { var f = drawer.querySelector('input[type="search"]'); if (f) f.focus(); }
      });
    }
  }

  /* Quantity steppers */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap.querySelector('input');
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      var val = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 1) + step);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Product page: variant selection + gallery */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-btn]');
    var priceEl = root.querySelector('[data-price]');
    var mainImg = root.querySelector('[data-main-image]');
    var money = root.getAttribute('data-money-format') || '{{amount}}';

    /* Sticky add-to-cart bar */
    var sticky = root.querySelector('[data-sticky-atc]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-btn]');
    var stickyVariant = sticky && sticky.querySelector('[data-sticky-variant]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    if (sticky) {
      stickyBtn.addEventListener('click', function () { addBtn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.hidden = !show;
          document.body.classList.toggle('has-sticky-atc', show);
        }).observe(addBtn);
      }
    }

    /* Low-stock urgency message */
    var stock = root.querySelector('[data-stock]');
    var invEl = root.querySelector('[data-inventory-json]');
    var inventory = invEl ? JSON.parse(invEl.textContent) : {};
    function renderStock(variant) {
      if (!stock) return;
      var info = inventory[variant.id];
      stock.hidden = true;
      stock.className = 'stock';
      if (!info || !variant.available) return;
      var threshold = parseInt(stock.getAttribute('data-threshold'), 10) || 0;
      var text = stock.querySelector('[data-stock-text]');
      if (info.tracked && info.qty > 0 && info.qty <= threshold) {
        text.textContent = (stock.getAttribute('data-message') || 'Only {count} left').replace('{count}', info.qty);
        stock.classList.add('stock--low');
        stock.hidden = false;
      } else if (stock.getAttribute('data-show-in-stock') === 'true') {
        text.textContent = 'In stock, ready to ship';
        stock.classList.add('stock--ok');
        stock.hidden = false;
      }
    }

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*\w+\s*\}\}/, amount).replace(/&[^;]+;/g, '');
    }

    function selected() {
      var vals = [];
      form.querySelectorAll('.opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals.push(c ? c.value : null);
      });
      return vals;
    }

    function update() {
      var vals = selected();
      /* Products with no options (single "Default Title" variant) render no radios */
      var variant = product.variants.length === 1 ? product.variants[0] : product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!variant) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      renderStock(variant);
      if (sticky) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = addBtn.textContent;
        stickyPrice.textContent = fmt(variant.price);
        stickyVariant.textContent = product.variants.length > 1 ? variant.title + ' · ' : '';
      }
      if (priceEl) {
        priceEl.innerHTML = (variant.compare_at_price > variant.price
          ? '<s class="price__compare">' + fmt(variant.compare_at_price) + '</s>' : '') +
          '<span class="price__current">' + fmt(variant.price) + '</span>';
        priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src.replace(/(\.\w+)(\?|$)/, '_900x$1$2');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      /* mark unavailable combos on the other options */
      form.querySelectorAll('.opt').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = vals.slice(); test[idx] = inp.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('.opt')) update();
    });
    update();

    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-large'); mainImg.alt = t.getAttribute('data-alt') || ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  ready(function () {
    var ann = document.querySelector('.announcement'); if (ann) initAnnouncements(ann);
    document.querySelectorAll('[data-hero]').forEach(initHero);
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initHeader();
    initQty();
  });

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    var h = root.querySelector('[data-hero]'); if (h) initHero(h);
    var p = root.querySelector('[data-product]'); if (p) initProduct(p);
    if (root.querySelector('.announcement')) initAnnouncements(root.querySelector('.announcement'));
  });
})();
